import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PasswordResetRequest } from '../../models/password-reset-request';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

   private apiUrl = environment.apiUrls.accountService;

  constructor(private http: HttpClient) {}

  verifyUser(token: string): Observable<{ success: boolean; message: string }> {
    return this.http.get<{ success: boolean; message: string }>(
      `${this.apiUrl}/verify?token=${token}`
    );
  }

  resetPassword(request: PasswordResetRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/reset-password`, request);
  }

  cleanPassToken(token: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/clean-pass-token`, token, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  getByPassToken(passToken: string): Observable<{ exists: boolean }> {
    return this.http.get<{ exists: boolean }>(
      `${this.apiUrl}/get-by-pass-token?passToken=${passToken}`
    );
  }

}
